import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { createConfigSlice } from './config';
import { createChartStoresSlice } from './chartStoreSlice';
import { createTrendCursorsSlice, } from '../echarts/extensions/trendCursors/store';
const useDataStore = create()(devtools(persist((...args) => ({
    ...createTrendCursorsSlice(...args),
    ...createConfigSlice(...args),
    ...createChartStoresSlice(...args),
}), {
    name: 'global-store',
    partialize: (state) => ({
        ...state,
        // chart stores are zustand store instances that
        // are persisted on their own and do not
        // nned to be serialized
        chartStores: {},
        groups: Object.entries(state.groups).reduce((groups, [groupId, grouping]) => {
            const groupingWithoutConnected = {
                ...grouping,
                // connectedCharts are a list of callback functions
                // they cannot be and don't need to be serialized
                connectedCharts: [],
            };
            groups[groupId] = groupingWithoutConnected;
            return groups;
        }, {}),
    }),
})));
export default useDataStore;
export const useGetConfigValue = (configName) => useDataStore((state) => state.config[configName]);
